import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Row, Col, Label, Modal, ButtonGroup } from 'reactstrap'
import _ from 'lodash'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import { toast } from 'react-toastify'
import { Redirect } from 'react-router-dom'
import Reflux from 'reflux'
import DynamicTable from 'Components/dynamicTable'

const createEmptyPageSection = () => ({
  PageSectionID: 0,
  BrandID: 0,
  category: '',
  title: '',
  bodyText: '',
  buttonText: '',
  buttonLink: '',
  imageUrl: '',
  imageAlignment: 'LEFT',
  backgroundColor: '',
  textColor: '',
  buttonBackgroundColor: '',
  buttonTextColor: '',
  timeStart: moment().format('YYYY-MM-DD'),
  timeEnd: ''
})

export const PageSectionForm = props => {
  const [pageSection, setPageSection] = useState(createEmptyPageSection())
  const [brands, setBrands] = useState([])
  const [pageSectionLoading, setPageSectionLoading] = useState(false)
  const [brandsLoading, setBrandsLoading] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const isMsbBrand = Reflux.GlobalState.LoginStore.settings.BrandID === 9
  const [links, setLinks] = useState([])
  const [showAddLinkModal, setShowAddLinkModal] = useState(false)
  const [addLinkBrandId, setAddLinkBrandId] = useState(null)

  const getPageSectionDetails = async PageSectionID => {
    setPageSectionLoading(true)

    const responseJson = await GET('pageSections/fetch', { PageSectionID: PageSectionID })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke hente forsidesektion: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setPageSection({
          ...responseJson,
          timeStart: moment(responseJson.timeStart).format('YYYY-MM-DD'),
          timeEnd: responseJson.timeEnd ? moment(responseJson.timeEnd).format('YYYY-MM-DD') : ''
        })
      }
    }

    setPageSectionLoading(false)
  }

  const savePageSection = async () => {
    setPageSectionLoading(true)

    if (!pageSection.timeEnd) {
      pageSection.timeEnd = null
    }
    const responseJson = await POST('pageSections/replace', pageSection)
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke gemme forsidesektion: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        toast.success('Forsidesektion er gemt', {
          autoClose: 7500
        })
        setRedirect(true)
      }
    }

    setPageSectionLoading(false)
  }

  const getBrands = async () => {
    setBrandsLoading(true)
    const responseJson = await GET('menus/listBrands')
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke hente brands: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setBrands(responseJson.filter(b => !b.removed))
      }
    }
    setBrandsLoading(false)
  }

  const uploadImage = async data => {
    const file = data.target.files[0]
    const responseJson = await Proxies.uploadImage(file)
    if (responseJson) {
      const imageUrl = responseJson.imageOriginSource ? responseJson.imageOriginSource : ''
      setPageSection({ ...pageSection, imageUrl: imageUrl })
    }
  }

  const getLinks = async PageSectionID => {
    const responseJson = await GET(`pageSections/getBrandLinksForPageSection`, { PageSectionID: PageSectionID })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke hente links: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setLinks(responseJson)
      }
    }
  }

  const addLink = async (PageSectionID, BrandID) => {
    const responseJson = await POST('pageSections/addBrandLink', { PageSectionID: PageSectionID, BrandID: BrandID })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke tilføje link: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setLinks([...links, { PageSectionID: PageSectionID, BrandID: BrandID, poolOrder: 0 }])
        toast.success(`Tilføjede link`, {
          autoClose: 7500
        })
      }
    }
  }

  const replaceLink = async (PageSectionID, BrandID, poolOrder) => {
    const responseJson = await POST('pageSections/replaceBrandLink', {
      PageSectionID: PageSectionID,
      BrandID: BrandID,
      poolOrder: poolOrder
    })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke opdatere link: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        const newLinks = links.map(l => {
          if (l.PageSectionID === PageSectionID) {
            return { ...l, poolOrder: poolOrder }
          } else {
            return l
          }
        })
        setLinks(newLinks)
        toast.success(`Opdaterede link`, {
          autoClose: 7500
        })
      }
    }
  }

  const removeLink = async (PageSectionID, BrandID) => {
    const responseJson = await POST('pageSections/removeBrandLink', { PageSectionID: PageSectionID, BrandID: BrandID })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke fjerne link: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        const newLinks = links.filter(l => l.BrandID !== BrandID)
        setLinks(newLinks)
        toast.success(`Fjernede link`, {
          autoClose: 7500
        })
      }
    }
  }

  const onAddLinkClick = () => {
    addLink(pageSection.PageSectionID, addLinkBrandId)
    setShowAddLinkModal(false)
  }

  useEffect(() => {
    const PageSectionID = _.get(props, 'match.params.PageSectionID')
    if (PageSectionID) {
      getPageSectionDetails(PageSectionID)
    } else {
      const emptyPageSection = createEmptyPageSection()
      setPageSection(emptyPageSection)
    }

    if (PageSectionID && isMsbBrand) {
      getBrands()
      getLinks(PageSectionID)
    }
  }, [])

  if (redirect) {
    return <Redirect to={'/page-sections'} />
  }

  if (pageSectionLoading) {
    return <FontAwesomeIcon icon='spinner' spin />
  }

  return (
    <>
      <CollapsibleCard startOpen header={<strong>{_.get(props, 'match.params.PageSectionID') ? 'Detaljer' : 'Opret'}</strong>}>
        <Form>
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='title'>Kategori</Label>
            </Col>
            <Col xs='10'>
              <Input type='text' value={pageSection.category} onChange={v => setPageSection({ ...pageSection, category: v.target.value })} />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='title'>Titel</Label>
            </Col>
            <Col xs='10'>
              <Input
                type='text'
                value={pageSection.title}
                onChange={v => setPageSection({ ...pageSection, title: v.target.value })}
                invalid={!pageSection.title.length}
              />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='bodyText'>Brødtekst</Label>
            </Col>
            <Col xs='10'>
              <Input type='textarea' value={pageSection.bodyText} onChange={v => setPageSection({ ...pageSection, bodyText: v.target.value })} />
            </Col>
          </Row>
          <Row className='mt-5'>
            <Col xs='2'>
              <Label for='imageUrl'>Billede</Label>
            </Col>
            <Col xs='10'>
              <Input name='' field='upload' type='file' data={{ upload: '' }} onChange={uploadImage} accept='image/*' />
              <img
                src={pageSection.imageUrl}
                style={{
                  height: '200px',
                  width: 'auto',
                  objectFit: 'cover',
                  marginTop: '10px',
                  marginBottom: '10px',
                  display: pageSection.imageUrl ? 'inline-block' : 'none'
                }}
              />
            </Col>
          </Row>

          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='imageAlignment'>Billede placering</Label>
            </Col>
            <Col xs='10'>
              <Input
                type='select'
                name='imageAlignment'
                value={pageSection.imageAlignment}
                id='imageAlignment'
                onChange={v => setPageSection({ ...pageSection, imageAlignment: v.target.value })}
              >
                <option value={'LEFT'}>{'Venstre'}</option>
                <option value={'RIGHT'}>{'Højre'}</option>
              </Input>
            </Col>
          </Row>
          <Row className='mt-5'>
            <Col xs='2'>
              <Label for='buttonText'>Knap tekst</Label>
            </Col>
            <Col xs='10'>
              <Input type='text' value={pageSection.buttonText} onChange={v => setPageSection({ ...pageSection, buttonText: v.target.value })} />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='buttonLink'>Knap link</Label>
            </Col>
            <Col xs='10'>
              <Input type='text' value={pageSection.buttonLink} onChange={v => setPageSection({ ...pageSection, buttonLink: v.target.value })} />
            </Col>
          </Row>
          <Row className='mt-5'>
            <Col xs='2'>
              <Label for='backgroundColor'>Baggrundsfarve</Label>
            </Col>
            <Col xs='10'>
              <Input
                type='color'
                value={pageSection.backgroundColor}
                onChange={v => setPageSection({ ...pageSection, backgroundColor: v.target.value })}
              />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='textColor'>Tekstfarve</Label>
            </Col>
            <Col xs='10'>
              <Input type='color' value={pageSection.textColor} onChange={v => setPageSection({ ...pageSection, textColor: v.target.value })} />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='buttonBackgroundColor'>Knap baggrundsfarve</Label>
            </Col>
            <Col xs='10'>
              <Input
                type='color'
                value={pageSection.buttonBackgroundColor}
                onChange={v => setPageSection({ ...pageSection, buttonBackgroundColor: v.target.value })}
              />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='buttonTextColor'>Knap tekstfarve</Label>
            </Col>
            <Col xs='10'>
              <Input
                type='color'
                value={pageSection.buttonTextColor}
                onChange={v => setPageSection({ ...pageSection, buttonTextColor: v.target.value })}
              />
            </Col>
          </Row>
          <Row className='mt-5'>
            <Col xs='2'>
              <Label for='poolOrder'>Rækkefølge</Label>
            </Col>
            <Col xs='10'>
              <Input
                type='number'
                value={pageSection.poolOrder}
                onChange={v => setPageSection({ ...pageSection, poolOrder: Number(v.target.value) })}
              />
            </Col>
          </Row>
          <Row className='mt-2 mb-3'>
            <Col xs='2'>
              <label>Vises fra/til</label>
            </Col>
            <Col xs='10'>
              <Row xs='12'>
                <Col xs='6'>
                  <Input type='date' value={pageSection.timeStart} onChange={v => setPageSection({ ...pageSection, timeStart: v.target.value })} />
                </Col>
                <Col xs='6'>
                  <Input type='date' value={pageSection.timeEnd} onChange={v => setPageSection({ ...pageSection, timeEnd: v.target.value })} />
                </Col>
              </Row>
            </Col>
          </Row>

          <Button onClick={savePageSection} disabled={!pageSection.title || (isMsbBrand && !pageSection.BrandID)}>
            Gem
          </Button>
          <Button color='danger' onClick={() => setPageSection(createEmptyPageSection())} className='ml-2'>
            Nulstil
          </Button>
        </Form>
      </CollapsibleCard>

      {isMsbBrand && pageSection.BrandID === 9 && (
        <CollapsibleCard startOpen header={<strong>Brand Links</strong>}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div>
              <Button onClick={() => setShowAddLinkModal(true)}>+ Add Link</Button>
            </div>
            <DynamicTable
              responsive
              size='sm'
              options={{
                startSort: {
                  dir: 'DESC',
                  column: 'PageSectionID'
                },
                fieldFunctions: {
                  poolOrder: e => {
                    return (
                      <Input
                        type='number'
                        defaultValue={e.poolOrder}
                        onBlur={v => {
                          replaceLink(e.PageSectionID, e.BrandID, Number(v.target.value))
                        }}
                        style={{ width: 100 }}
                      />
                    )
                  },
                  brand: e => {
                    const brand = brands.find(b => b.BrandID === e.BrandID)
                    return <>{brand?.brandName}</>
                  }
                },
                addField: e => {
                  return (
                    <td>
                      <ButtonGroup>
                        <Button
                          color='danger'
                          onClick={() => {
                            if (confirm('Vil du slette dette link?')) {
                              removeLink(e.PageSectionID, e.BrandID)
                            }
                          }}
                        >
                          <FontAwesomeIcon icon='trash' />
                        </Button>
                      </ButtonGroup>
                    </td>
                  )
                }
              }}
              headers={{
                BrandID: 'Brand ID',
                brand: 'Brand',
                poolOrder: 'Rækkefølge'
              }}
              data={links}
            />
          </div>
        </CollapsibleCard>
      )}
      <Modal isOpen={showAddLinkModal} toggle={() => setShowAddLinkModal(false)}>
        <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 20 }}>
          <b>Add link</b>
          {brandsLoading ? (
            <FontAwesomeIcon icon='spinner' spin />
          ) : (
            <Input invalid={!addLinkBrandId} type='select' value={Number(addLinkBrandId)} onChange={v => setAddLinkBrandId(Number(v.target.value))}>
              <option value=''>Vælg</option>
              {brands.map((b, i) => {
                return (
                  <option value={Number(b.BrandID)} key={i}>
                    {b.BrandID} - {b.brandName}
                  </option>
                )
              })}
            </Input>
          )}
          <Button onClick={onAddLinkClick}>Add link</Button>
        </div>
      </Modal>
    </>
  )
}
